import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { getMyCompanies } from 'src/api/company';
import { getUserPreferences } from 'src/api/userPreferences';

export const Route = createFileRoute('/company_/')({
	component: RouteComponent,
});

function RouteComponent() {
	const { data: groups, isLoading: groupsLoading } = useQuery({
		queryKey: ['company-groups'],
		queryFn: () => getMyCompanies(),
	});

	const { data: userPreferences, isLoading: prefsLoading } = useQuery({
		queryKey: ['user-preferences'],
		queryFn: () => getUserPreferences(),
	});

	if (groupsLoading || prefsLoading) {
		return null;
	}

	if (!groups || groups.length === 0) {
		return (
			<div className="flex items-center justify-center h-full">
				<p>You don't have access to any companies.</p>
			</div>
		);
	}

	const activeGroupId = userPreferences?.companyPortalActiveGroupId;
	const targetGroup = activeGroupId && groups.find((g) => g.id === activeGroupId) ? activeGroupId : groups[0].id;

	return <Navigate to="/company/$groupId/information" params={{ groupId: targetGroup }} replace />;
}
